import React from "react";
import EditableText from "./EditableText";
import { useContent } from "../context/ContentContext";

export default function Hero() {
  const { content } = useContent();
  const hero = content?.hero;
  if (!hero) return null;

  return (
    <section
      id="top"
      className="relative min-h-[92vh] flex items-end overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={hero.background_image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Light left-to-right wash for text legibility only — no heavy navy shadow */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-black/10 to-transparent" />
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1400px] px-6 md:px-12 pb-20 md:pb-28 pt-32 md:pt-40">
        <div className="max-w-4xl fade-up">
          <EditableText
            path="hero.headline"
            value={hero.headline}
            as="h1"
            multiline
            preserveWhitespace
            className="font-serif text-[#F9F8F6] text-4xl sm:text-5xl md:text-6xl lg:text-[72px] leading-[1.4] tracking-tight font-medium mb-10 text-balance drop-shadow-[0_2px_24px_rgba(0,0,0,0.35)]"
            testId="hero-headline"
          />
          <EditableText
            path="hero.subheadline"
            value={hero.subheadline}
            as="p"
            multiline
            className="text-[#F9F8F6] text-base md:text-lg leading-relaxed max-w-xl drop-shadow-[0_2px_16px_rgba(0,0,0,0.45)]"
            testId="hero-subheadline"
          />
        </div>
      </div>
    </section>
  );
}
